"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Z20Entity {
    constructor(index, config) {
        this.index = index;
        this.gives = config.gives;
        this.kills = !!config.kills;
        this.wins = !!config.wins;
        this.weakness = config.weakness;
        this.player = !!config.player;
        this.sprite = config.sprite;
        this.animates = !this.wins;
    }
}
exports.default = Z20Entity;
